import { Link } from "react-router-dom";
import PageTitle from "../components/ui/PageTitle";
import { useTheme } from "../components/Theme";


export default function About() {

  const { darkMode, toggleModes } = useTheme();

  const pageTitle = darkMode
    ? "text-white "
    : "text-black ";



  return (
    <>
      <div className="page-div">
        <div data-aos="fade-down" className="title-area w-full">
          <PageTitle
            title="About Us"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "About us", path: "/about" },
            ]}
          />
        </div>

        <div data-aos="fade-up" className="aboutus-wrapper w-full">
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">



              <div className="content flex-1">
                <h1 className={`text-3xl font-bold text-qblack mb-2.5 ${pageTitle}`}>
                  What is MarketFusion?
                </h1>
                <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                  Let us help you kickstart your business by:
                </p>
                <ul className="text-[15px] text-qgraytwo leading-7 list-disc ml-5 mb-5">
                  <li>Choosing your contract manufacturing of choice</li>
                  <li>Understanding your business needs</li>
                  <li>Bring your ideas to life</li>
                </ul>

                <Link to="/contact">
                  <div className="w-[121px] h-10">
                    <span className="blue-btn">Contact Us</span>
                  </div>
                </Link>
              </div>

              <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden my-5 lg:my-0">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/about-events.png`}
                  alt="about"
                  className="w-full h"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
